angular.module('zc.zenclerkS')

  .component('zcsExcludePageForm', {
    bindings: {
      project: '=',
      baseUrl: '=',
      pageTypes: '=',
      onDestroy: '&',
    },
    templateUrl: '/templates/zenclerk_s/directives/exclude_page_editor/exclude_page_form.html',
    controllerAs: 'vm',
    controller: function($scope, $translate, Meta, PageType) {
      const vm = this;
      const EXCLUDE_PAGE_TYPE_LIMIT = 500;
      vm.isDestroying = false;
      vm.isSaving = false;
      vm.excludedPageTypeLimit = EXCLUDE_PAGE_TYPE_LIMIT;

      Meta.getPageTypeMatchTypes().then(res => {
        const regexp = _.findIndex(res, { name: 'regexp' });
        if(regexp !== -1) {
          res.splice(regexp, 1);
        }
        for(const pt of res) {
          pt.label = $translate.instant('directives.excludePage.' + pt.name);
        }
        vm.matchTypes = res;
      });

      vm.savePageType = () => {
        vm.isSaving = true;
        const updatePages = [];
        const createPages = [];

        for(const pt of vm.pageTypes) {
          if(pt.id) {
            if(pt.isModified) {
              delete pt.isModified;
              updatePages.push(pt);
            }

          } else {
            delete pt.isModified;
            createPages.push(pt);
          }
        }
        if(createPages.length > 0) {
          PageType.createMany({projectId: vm.project.id}, createPages)
            .then(mergePageType);
        }

        if(updatePages.length > 0) {
          PageType.updateMany({projectId: vm.project.id}, updatePages)
            .then(mergePageType);
        }
      };

      vm.destroyPageType = pageType => {
        if(!pageType.id) {
          vm.onDestroy(pageType);
        } else {
          vm.isDestroying = true;
          PageType.destroy(pageType)
            .then(res => {
              vm.onDestroy(pageType);
              vm.isDestroying = false;
              // When rule is deleted, refresh the exclusion rate which is in parent scope
              $scope.$parent.vm.queryMongoHistoryToCalcExclusionPercentage();
            });
        }
      };

      vm.onDestroy = pageType => {
        if(!pageType) return;
        /* eslint-disable angular/no-private-call */
        const pageTypeIndex = vm.pageTypes.findIndex(pt => pt.$$hashKey === pageType.$$hashKey);
        if(pageTypeIndex !== -1) {
          vm.pageTypes.splice(pageTypeIndex, 1);
        }
      };

      function mergePageType(res) {
        vm.isSaving = false;
        $scope.excludePageForm.$setPristine();
        // When rule is added, refresh the exclusion rate which is in parent scope
        $scope.$parent.vm.queryMongoHistoryToCalcExclusionPercentage();
        return res;
      }

      vm.addPageType = () => {
        vm.pageTypes.push(PageType.new({
          project_id: vm.projectId,
          page_type: 'no_publish',
          match_pattern: '/',
          match_type: 'prefix'
        }));
      };

      vm.pageTypeChanged = pageType => {
        pageType.isModified = true;
      };
    }
  });



// WEBPACK FOOTER //
// ./src/zenclerk_s_modules/zenclerk_s/directives/exclude_page_editor/exclude_page_form.js